import posthog from 'posthog-js';

function capture(eventName: string, properties?: Record<string, unknown>): void {
    if (posthog.__loaded) {
        posthog.capture(eventName, properties ?? {});
    }
}

export const analytics = {
    eeEeaReportGenerated: () => capture('ee_eea_report_generated'),
    eeDashboardPowerpointGenerated: () => capture('ee_dashboard_powerpoint_generated'),
    eeDataImported: (importType: string) => capture('ee_data_imported', { import_type: importType }),
    eeDataExported: (importType: string) => capture('ee_data_exported', { export_type: importType }),
    eeGroupDataImported: () => capture('ee_group_data_imported'),
    cdmManualDataImported: (importType: string) => capture('cdm_manual_data_imported', { import_type: importType }),
    cdmPayrollDataImported: () => capture('cdm_payroll_data_imported'),
};
